import { Modal, Row, Col } from 'antd';

const FeedbackModal = ({ 
  open, 
  onClose, 
  type = 'success',
  t
}) => {

  const getConfig = () => {
    switch (type) {
      case 'success':
        return {
          icon: <span className="icon-brand-feedback" title="icon-brand-feedback" />,
          message: t('medicalConsultations.reportPage.successMessage')
        };
      case 'error':
        return {
          icon: <span className="icon-error-rounded" title="icon-error-rounded" />,
          message: t('medicalConsultations.reportPage.errorMessage')
        };
      default:
        return {
          icon: <span className="icon-brand-feedback" title="icon-brand-feedback" />,
          message: t('medicalConsultations.reportPage.successMessage')
        };
    }
  };

  const config = getConfig();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      closable={true}
      centered
      width={400}
      mask={false}
      className="report-change-feedback-modal"
    >
      <Row justify="center">
        <Col span={24}>
          <Row justify="center">
            <Col>
              {config.icon}
            </Col>
          </Row>
          <Row justify="center">
            <Col>
              <p>
                {config.message}
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export default FeedbackModal;